module.exports = "<round-progress max=totalSteps current=completedSteps color={{color}} bgcolor={{bgcolor}} radius={{radius}} stroke={{stroke}} semi=false rounded=rounded clockwise=true responsive=responsive animation-delay=150 duration=800 animation=easeInOutQuart animation-delay=0 ng-if=\"progressCompleted() === false\"></round-progress> <div ng-if=\"progressCompleted() === true\"> <div class=circle-container> <div class=\"circle circle-filled\" ng-style=completionImageStyle> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/progress-checkmark/ws-progress-checkmark.tmpl.html
// module id = 75
// module chunks = 0